import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'actorFilter',
    pure: false
    })

export class NotesSidePanelActorfilterPipe implements PipeTransform {
    transform(items: any[], notesFilter?: any,actorId?: any) {
        let filteredData=[];
            if(notesFilter == 'my'){
                filteredData = items.filter((item) => item.actor.id === actorId);
            }else if(notesFilter == 'others'){
                filteredData = items.filter((item) => item.actor.id !== actorId);
            }else{
                filteredData = items;
            }
        return filteredData;
    }
}
